import * as React from "react";

import styled from "../../theme/styled";
import DynamicImage from "../dynamic-image";
import {
  DynamicWrapper,
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphImageColumnWidthWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
}

const ParagraphImageColumnWidthWrapper = styled<
  IParagraphImageColumnWidthWrapper,
  "div"
>("div")`
  .content-container {
    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

const ParagraphImageColumnWidth = ({ type, content }: IProps) => {
  const imgRel = content.relationships;
  const image = imgRel && imgRel.field_image;

  if (!image) {
    return null;
  }

  return (
    <ParagraphImageColumnWidthWrapper
      className="paragraph-image-column-width"
      type={type}
    >
      <DynamicWrapper type={type}>
        <DynamicImage
          data={image}
          alt={content.field_image.alt}
        />
      </DynamicWrapper>
    </ParagraphImageColumnWidthWrapper>
  );
};

export default ParagraphImageColumnWidth;
